import { render, staticRenderFns } from "./Ophthalmic.vue?vue&type=template&id=0064d640&"
import script from "./Ophthalmic.vue?vue&type=script&lang=js&"
export * from "./Ophthalmic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports